import React, { useEffect, useState } from "react";
import NavBar from "../../components/Influencer/NavBar";
import InfiniteScroll from "react-infinite-scroll-component";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import {
  RefferedUsers,
  InfluencerData,
} from "../../redux/actions/InfluencerAction";
import { getDate } from "../../helpers/TimeDate";
import Loder from "../../components/loder";
const InfluencerDashboard = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("INFLUENCER"));

  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [refferalUsers, setRefferalUsers] = useState(null);
  const [signupUser, setSignupUser] = useState(0);
  const [demo, setDemo] = useState(0);
  const [appCopyed, setAppCopy] = useState(false);
  const [webCopyed, setWebCopy] = useState(false);
  const [loadMore, setLoadMore] = useState(true);
  const [openSnackbar, closeSnackbar] = useSnackbar();

  useEffect(() => {
    if (!user) {
      history.push("/affiliate/login");
    }
    InfluencerData();
  }, [user]);

  useEffect(() => {
    if (user) {
      const data = {
        referalCode: user.refferalcode,
        page: page,
        limit: 50,
      };

      const onSuccess = (data) => {
        console.log(data);
        setTotalPage(data.pagianationCount);
        setRefferalUsers(data.totalRefferl);
        setSignupUser(data.signupUser);
        setDemo(data.demoBooked);
        if(data.totalRefferl.length < 1){
          setLoadMore(false)
        }

        page++;

      };
      const onError = (msg) => {
        console.log(msg);
      };

      RefferedUsers(data, onSuccess, onError);
    }
  }, []);

  function handleScrolll() {
    const data = {
      referalCode: user.refferalcode,
      page: page + 1,
      limit: 50,
    };
    const onSuccess = (data) => {
      setTotalPage(data.pagianationCount);
      setRefferalUsers([...refferalUsers, ...data.totalRefferl]);
      setSignupUser(data.signupUser);
      setDemo(data.demoBooked);
      setPage(page + 1);
    };
    const onError = (msg) => {
      openSnackbar(msg);
    };

    if (page <= totalPage) {
      RefferedUsers(data, onSuccess, onError);
    } else {
      setLoadMore(false);
    }
  }

  return (
    <div>
      <NavBar />

      <div className="dashboard_container container">
        <h3 className="hii">
          Hii Influencer your referral code is{" "}
          <span className="text-info">{user ? user.refferalcode : ""}</span>
        </h3>
        {user ? (
          <div className="row pt-4 pb-4">
            <div className="col-md-6">
              <label className="form-label">App UTM Link :</label>
              <CopyToClipboard
                text={`https://play.google.com/store/apps/details?id=com.app.clapingo&referrer=${user.refferalcode}`}
                onCopy={() => {
                  openSnackbar("Referral link copied successfully");
                  setAppCopy(true);
                }}
              >
                <input
                  type="text"
                  className={`form-control ${appCopyed ? "bg-warning" : ""}`}
                  value={`https://play.google.com/store/apps/details?id=com.app.clapingo&referrer=${user.refferalcode}`}
                />
              </CopyToClipboard>
            </div>
            <div className="col-md-6">
              <label className="form-label">Web UTM Link :</label>
              <CopyToClipboard
                text={`https://clapingo.com/home/${window.btoa(
                  user.refferalcode
                )}`}
                onCopy={() => {
                  openSnackbar("Referral link copied successfully");
                  setWebCopy(true);
                }}
              >
                <input
                  type="text"
                  className={`form-control ${webCopyed ? "bg-warning" : ""}`}
                  value={`https://clapingo.com/home/${window.btoa(
                    user.refferalcode
                  )}`}
                />
              </CopyToClipboard>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row  mt-3">
          <div className="col-md-3 earning">
            <div className="card">
              <div className="card-body">
                <div className="count_content ">
                  <p>Your Earning</p>
                  <h4>₹ {user ? Math.round(user.earning) : "loading.."}</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 mt-4 mt-md-0 subscribe">
            <div className="card">
              <div className="card-body">
                <div className="count_content">
                  <p>Subscribed User</p>
                  <h4>{user ? user.subscribedUser : "loading.."}</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 demo">
            <div className="card">
              <div className="card-body">
                <div className="count_content">
                  <p>Demo Taken</p>
                  <h4>{demo}</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 link">
            <div className="card">
              <div className="card-body">
                <div className="count_content">
                  <p>Signup User</p>
                  <h4>{signupUser}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-row-reverse">
          <button
            className="btn btn-success mt-2"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>

        <div className="referral_overview">
          <div className="card p-3">
            <div className="table_container">
              <InfiniteScroll
                dataLength={refferalUsers ? refferalUsers.length : 0}
                next={() => handleScrolll()}
                hasMore={true}
                loader={loadMore ? <Loder /> : ""}
                style={{ overflow: "hidden" }}
              >
                <table className="table table-hover  ">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Customer Name</th>
                      <th scope="col">Subscription Amount</th>
                      <th scope="col">Subscription Date</th>
                      <th scope="col">Affiliate Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    {refferalUsers
                      ? refferalUsers.map((data, index) => (
                          <tr key={data._id}>
                            <th scope="row">{index + 1}</th>
                            <td>{data.learner.name}</td>
                            <td>₹ {data.amountWithoutGST}/-</td>
                            <td>
                              {data.createdAt ? getDate(data.createdAt) : "N/A"}
                            </td>
                            <td>
                              ₹{" "}
                              {Math.round(
                                data.amountWithoutGST * user.affiliatefee * 0.01
                              )}
                              /-
                            </td>
                          </tr>
                        ))
                      : ""}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfluencerDashboard;
